module.exports = __webpack_public_path__ + "static/3-7e22871b84c63c1fd0f93309fbdc8fe2.jpg";